import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import ContentLoader from 'react-content-loader';

const ItemImportListLoader = props => {
  const themeContext = useContext(ThemeContext);

  const ItemRow = props => {
    const random = Math.random() * (1 - 0.7) + 0.7;
    return (
      <ContentLoader {...props}>
        <rect x="0" y="0" rx="0" ry="0" width="5" height="48" />
        <rect x="15" y="6" rx="0" ry="0" width={200 * random} height="14" />
        <rect x="15" y="33" rx="0" ry="0" width={300 * random} height="10" />
        <rect x="440" y="30" rx="0" ry="0" width={20} height="20" />
      </ContentLoader>
    );
  };

  return Array(6)
    .fill('')
    .map((e, i) => (
      <ItemRow
        key={i}
        style={{ opacity: Number(1 / i).toFixed(1) }}
        speed={2}
        width={470}
        height={48}
        viewBox="0 0 470 48"
        backgroundColor={themeContext?.loadingTableColor}
        foregroundColor={themeContext?.loadingTableColorLight}
      />
    ));
};

export default ItemImportListLoader;
